import type { Locale } from '~/i18n/i18n-config';

const LONDON_ORIGIN_ID = 26;
const AMSTERDAM_ORIGIN_ID = 22_370_654;

// The trip origin used when a visitor hasn't chosen one. Locales not listed fall back to London.
const DEFAULT_ORIGIN_ID_BY_LOCALE: Partial<Record<Locale, number>> = {
  'nl-NL': AMSTERDAM_ORIGIN_ID
};

export const DEFAULT_ORIGIN_ID = LONDON_ORIGIN_ID;

export function getDefaultOriginId(locale?: string): number {
  return DEFAULT_ORIGIN_ID_BY_LOCALE[locale as Locale] ?? DEFAULT_ORIGIN_ID;
}

// Blueprint prices from the CMS and the engine default to London, so only other origins need repricing.
export function getNonLondonOriginId(locale?: string): number | undefined {
  const originId = getDefaultOriginId(locale);
  return originId === DEFAULT_ORIGIN_ID ? undefined : originId;
}

export const DEFAULT_BUILD_NIGHTS = '9';

// Engine prices assume this many adults; divide by it for a per-person price.
export const DEFAULT_PAX_COUNT = 2;

/** Search params for a bare `/map/build` entry: `?origin=<id>&nights=9`. */
export function getDefaultBuildSearch(locale?: string): string {
  return `?origin=${getDefaultOriginId(locale)}&nights=${DEFAULT_BUILD_NIGHTS}`;
}
